<div class="background-img">
  <div class="background">
    @if (maintenanceTextNL) {
      <mat-card appearance="outlined" class="maintenance-card">
        <p>{{ maintenanceTextNL }}</p>
        <p>{{ maintenanceTextEN }}</p>
      </mat-card>
    }
    <mat-card class="loginCard card-primary" appearance="outlined">
      <div class="card-title-background-box">
        <img class="logo" src="assets/images/logo.jpg" alt="" srcset="" />
      </div>
      <mat-card-content>
        <p style="margin-left: 5px">{{ 'login.form.email-header' | translate | capitalize }}</p>
        <mat-form-field [hideRequiredMarker]="true" appearance="outline" style="width: 100%">
          <mat-label>{{ 'account.email' | translate | capitalize }}</mat-label>
          <input matInput [disabled]="preventLogin" [formControl]="emailFormControl" (keyup.enter)="onSsoLogin()" />
          @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
            <mat-error>
              {{ 'login.form.invalid-email' | translate | capitalize }}
            </mat-error>
          }
          @if (emailFormControl.hasError('required')) {
            <mat-error>
              {{ 'general.inputs.errors.required' | translate | capitalize }}
            </mat-error>
          }
        </mat-form-field>
        @if (showSchoolList) {
          <p class="show-school-list">
            {{ 'login.form.school-not-found' | translate | capitalize }}
          </p>
        }
        @if (showSchoolList) {
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ 'login.form.choose-school' | translate | capitalize }}</mat-label>
            <mat-select [formControl]="schoolSelectFormControl" [disabled]="preventLogin">
              @for (school of schools; track school) {
                <mat-option [value]="school.id">
                  {{ school.name }}
                </mat-option>
              }
            </mat-select>
            @if (schoolSelectFormControl.hasError('required')) {
              <mat-error>
                {{ 'general.inputs.errors.required' | translate | capitalize }}
              </mat-error>
            }
          </mat-form-field>
        }
        <div class="actions-wrapper">
          @if (!showSchoolList) {
            <app-spinner-button
              [config]="btnConfig"
              style="margin-top: 5px"
              (onClick)="onSsoLogin()"
              [disabled]="preventLogin || emailFormControl.invalid"></app-spinner-button>
          }
          @if (showSchoolList) {
            <app-spinner-button
              [config]="schoolSelectedBtnConfig"
              style="margin-top: 5px"
              (onClick)="onSsoLogin()"
              [disabled]="
                preventLogin || emailFormControl.invalid || schoolSelectFormControl.invalid
              "></app-spinner-button>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div class="lang-card">
  <mat-icon style="color: #5c739d">language</mat-icon>
  <mat-form-field class="lang-dropdown" appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-select appearance="none" [formControl]="languageSelectFormControl" (selectionChange)="onLangChange($event)">
      @for (lang of languages; track lang) {
        <mat-option [value]="lang">
          {{ lang.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="secret-manual-login-button" routerLink="/login/beheer"></div>
